import { create } from "zustand";
const useSharedLinksStore = create((set) => ({
    addLink: (link) => set((state) => ({
        links: [link, ...state.links]
    })),
    // Start with empty links array - will be populated from API
    links: [],
    removeLink: (linkUrl) => set((state) => ({
        links: state.links.filter((link) => link.link !== linkUrl)
    })),
    setLinks: (links) => set(() => ({
        links
    })),
    updateLink: (linkUrl, updatedData) => set((state) => ({
        links: state.links.map((link) => (link.link === linkUrl ? { ...link, ...updatedData } : link))
    }))
}));
export default useSharedLinksStore;
